<template>
  <div class="md-layout">
    <div v-if="$route.params.id" id="objectHeaderContentHidden" style="display: none;">
      <div>
        <md-icon class="icon-color">{{formConfig.headerIcon}}</md-icon>
      </div>
      <div>
        <h1 class="md-title icon-color content-wrap">{{recordData? recordData.name : ''}}</h1>
      </div>
    </div>
    <template v-if="$route.params.id">

      <md-tabs md-sync-route class="topNavTabs">
        <md-tab id="tab-salesoffice" md-label="Sales Office" :to="recordPath" exact>
          <ConfigForm
            :update="updateForm"
            :form="form"
            :$v="$v"
            :formConfig.sync="formConfig"
            :headerColor="headerColor"
          ></ConfigForm>
        </md-tab>
      </md-tabs>
    </template>

    <div v-else class="md-layout-item md-small-size-100">
      <ConfigForm
        :update="updateForm"
        :form="form"
        :$v="$v"
        :formConfig="formConfig"
        :headerColor="headerColor"
      ></ConfigForm>
    </div>
  </div>
</template>

<script>
import Record from "@/mixins/Record";

// Form validations
import { required, numeric, minLength, email } from "vuelidate/lib/validators";

export default {
  name: "salesoffices",
  mixins: [Record],
  computed: {},
  data() {
    return {
      formConfig: {
        hasUpdatedBy: true,
        updatedByFieldName: 'salesOfficeUpdatedById',
        responseFieldName: "getSalesOffice",
        actions: {
          save: "createSalesOffice",
          view: "editSalesOffice",
          edit: "editSalesOffice",
          new: "getSalesOffice",
          update: "updateSalesOffice",
          delete: "deleteSalesOffice"
        },
        slots: {
          basic: { label: "Basic Information", icon: "business" , layout: {"x":0,"y":0,"w":12,"h":18,"i":"0"}},
        },
        listPath: "/salesoffice",
        headerIcon: "business",
        objectName: "SalesOffice",
        objectNamePlural: "Sales Offices",
        editMode: false,
        pageMode: 'new',
        fields: {
          id: { label: "ID", type: "id", slot: "basic" },
          name: { label: "Name", type: "text", slot: "basic" },
          active: {
            label: "Active",
            type: "switch",
            slot: "basic",
            value: true
          }
        },
        editTitleField: "name"
      },
      form: {
        id: "",
        name: "",
        active: true
      }
    };
  },
  validations() {
    return {
      form: {
        id: {},
        name: { required, minLength: minLength(3) },
        active: {}
      }
    };
  }
};
</script>

<style lang="scss">
.md-tabs .md-tabs-navigation {
  padding-left: 15px;
  color: black;
  display: none;
  .md-tab-nav-button.md-button {
    color: black !important;

    &.active {
      color: black !important;
      border-bottom: 2px solid black;
    }
  }
}

.md-content .md-tabs-container .md-tab > .md-layout-item {
  padding-left: 0;
  padding-right: 0;
}
</style>
